// @flow

import { createSelector } from 'reselect'

type Action = {
  +type: string,
  payload: Object,
}

//Constants
export const FETCH_PUBLISHERS_REPORT_REQUEST =
  'opinary/FETCH_PUBLISHERS_REPORT_REQUEST'
export const FETCH_PUBLISHERS_REPORT_SUCCESS =
  'opinary/FETCH_PUBLISHERS_REPORT_SUCCESS'
export const CHANGE_METRIC = 'opinary/CHANGE_METRIC'

const InitialReportState = {
  customer: '',
  createdLte: Date.now(),
  createdGte: Date.now(),
  spans: [],
  totals: {
    impressions: 0,
    clicks: 0,
    conversion: 0,
  },
}

// Root Selector
export const getRoot = (state: Object) => state

export const getReport = createSelector(
  getRoot,
  ({ publisherReport }) => publisherReport.data || InitialReportState
)

export const getReportSpans = createSelector(
  getReport,
  ({ spans }) => spans || []
)

export const getLoadingState = createSelector(
  getRoot,
  ({ publisherReport }) => publisherReport.isloading || false
)

export const getCurrentMetric = createSelector(
  getRoot,
  ({ publisherReport }) => publisherReport.metric || 'impressions'
)

//Actions
export const fetchPublisherReport = (date: Date) => ({
  type: FETCH_PUBLISHERS_REPORT_REQUEST,
  payload: date,
})

export const changeMetric = (metric: string) => ({
  type: CHANGE_METRIC,
  payload: metric,
})

const initalState = {
  isloading: false,
  metric: 'impressions',
}

const publishersReport = (state: Object = initalState, action: Action) => {
  switch (action.type) {
    case FETCH_PUBLISHERS_REPORT_REQUEST:
      return {
        ...state,
        isloading: true,
      }

    case CHANGE_METRIC:
      return {
        ...state,
        metric: action.payload,
      }
    case FETCH_PUBLISHERS_REPORT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isloading: false,
      }
    default:
      return state
  }
}

export default publishersReport



// WEBPACK FOOTER //
// ./src/stores/report/publishers.js